/* eslint-disable no-restricted-syntax,prefer-const,no-param-reassign,no-unused-vars,no-console */
import {
    FETCH_SUPPLIERS,
    FETCH_BUILDINGS,
    ADD_BUILDING,
    UPDATE_BUILDING,
    ADD_FIELD,
    DELETE_FIELD,
    // ADD_PANEL,
    FETCH_PANEL_STATUSES,
    RESET_STATE,
    ADD_PANEL,
    UPDATE_PANEL,
    DELETE_PANEL,
    DELETE_BUILDING,
    UPDATE_ALL_PANEL_PRICES,
    FETCH_USERS,
    UPDATE_USER,
    CREATE_USER,
    CREATE_SUPPLIER,
    UPDATE_SUPPLIER,
    DELETE_ORDER,
    FETCH_ORDERS,
    ORDER_STATUS_UPDATE,
    ORDER_COMMENT_UPDATE,
    FETCH_BUILDING,
    FETCH_FIELD,
    FETCH_WORDING,
    DELETE_ORDER_PANEL,
    FETCH_ROLES,
    UPDATE_SUPPLIER_SETTINGS, DELETE_USER,
} from './types';
import { initialState } from './state';

export default {
    [FETCH_WORDING] (state, payload) {
        const wordings = {};
        if (state.auth.access_rights.name === 'admin') {
            wordings.default = {};
        }

        payload = payload.data || payload;
        payload.map((word) => {
            if (state.auth.access_rights.name === 'admin') {
                if (word.supplier) {
                    wordings[word.supplier.id] = {};
                    wordings[word.supplier.id][word.key] = word.label;
                } else {
                    wordings.default[word.key] = word.label;
                }
            } else {
                wordings[word.key] = word.label;
            }

            return word;
        });

        state.wordings = wordings;
    },
    [FETCH_ORDERS] (state, orders) {
        state.total_orders = orders.data.total;
        state.orders = orders.data;
    },
    [ORDER_STATUS_UPDATE] (state, updatedOrder) {
        let order = this.getters.get_order(updatedOrder.id);
        order.status = updatedOrder.status;
    },
    [ORDER_COMMENT_UPDATE] (state, updatedOrder) {
        let order = this.getters.get_order(updatedOrder.id);
        order.comment = updatedOrder.comment;
    },
    [DELETE_ORDER] (state, orderId) {
        const orders = this.getters.get_orders.data;
        state.orders.data.splice(orders.indexOf(this.getters.get_order(orderId)), 1);
    },
    [DELETE_ORDER_PANEL] (state, order) {
        state.orders.data = state.orders.data.map((one) => {
            if (one.id === order.id) {
                one = order;
            }
            return one;
        });
    },
    [FETCH_USERS] (state, users) {
        state.users = users.data;
    },
    [FETCH_ROLES] (state, roles) {
        state.roles = roles.data;
    },
    [CREATE_USER] (state, user) {
        state.users.push(user);
    },
    [UPDATE_USER] (state, updatedUser) {
        let user = this.getters.get_user(updatedUser.id);
        user = { ...updatedUser };
    },
    [DELETE_USER] (state, userId) {
        let deletedUser = this.getters.get_user(userId);
        state.users.splice(state.users.indexOf(deletedUser), 1);
    },
    [FETCH_SUPPLIERS] (state, suppliers) {
        state.suppliers = suppliers.data;
    },
    [CREATE_SUPPLIER] (state, supplier) {
        state.suppliers.push(supplier);
    },
    [UPDATE_SUPPLIER] (state, supplier) {
        const supplierIndex = state.suppliers.indexOf[state.suppliers.find(one => one.id === supplier.id)];
        state.suppliers[supplierIndex] = supplier;
    },
    [UPDATE_SUPPLIER_SETTINGS] (state, supplierSettings) {
    },
    [FETCH_BUILDINGS] (state, buildings) {
        state.buildings = buildings.data;
    },
    [FETCH_BUILDING] (state, fetchedBuilding) {
        const buildings = this.getters.get_buildings;

        if (!buildings) {
            state.buildings = [];
            state.buildings.push(fetchedBuilding);
        } else {
            let building = this.getters.get_building(fetchedBuilding.id);
            Object.assign(building, fetchedBuilding);
        }
    },
    [ADD_BUILDING] (state, building) {
        state.buildings.push(building);
    },
    [UPDATE_BUILDING] (state, building) {
        const stateBuilding = this.getters.get_building(building.id);
        const buildingIndex = state.buildings.indexOf(stateBuilding);
        state.buildings[buildingIndex] = building;
    },
    [DELETE_BUILDING] (state, building) {
        const buildingIndex = state.buildings.indexOf(building);
        state.buildings.splice(buildingIndex, 1);
    },
    [ADD_FIELD] (state, { field, building }) {
        let stateBuilding = this.getters.get_building(building.id);
        stateBuilding.total_panels += field.number_of_panels;
        stateBuilding.total_available_panels += field.available_panels;
        stateBuilding.number_of_fields += 1;
        stateBuilding.fields.count += 1;
        stateBuilding.fields.push(field);
    },
    [FETCH_FIELD] (state, fetchedField) {
        const building = this.getters.get_building(fetchedField.building.id);
        let field = this.getters.get_field(building, fetchedField.id) || {};
        Object.assign(field, fetchedField);
    },
    [DELETE_FIELD] (state, { field, building }) {
        const buildingIndex = state.buildings.indexOf(building);
        state.buildings[buildingIndex].total_panels -= field.number_of_panels;
        state.buildings[buildingIndex].total_available_panels -= field.available_panels;
        state.buildings[buildingIndex].number_of_fields -= 1;
        state.buildings[buildingIndex].fields.count -= 1;
        const fieldIndex = state.buildings[buildingIndex].fields.indexOf(field);
        state.buildings[buildingIndex].fields.splice(fieldIndex, 1);
    },

    [FETCH_PANEL_STATUSES] (state, statuses) {
        state.statuses = statuses;
    },
    [ADD_PANEL] (state, panel) {
        const building = state.buildings.find(one => one.id === panel.building_id);
        const field = building.fields.find(one => one.id === panel.field_id);

        field.panels.push(panel);
        field.panels.count += 1;
        field.number_of_panels += 1;
        building.total_panels += 1;

        if (panel.status_name === 'available') {
            building.total_available_panels += 1;
            field.available_panels += 1;
        }
    },
    [UPDATE_PANEL] (state, updatedPanel) {
        const building = state.buildings.find(one => one.id === updatedPanel.building_id);
        const field = building.fields.find(one => one.id === updatedPanel.field_id);
        let panel = field.panels.find(one => one.id === updatedPanel.id);

        if (panel.status_name === 'available' && updatedPanel.status_name !== 'available') {
            building.total_available_panels -= 1;
            field.available_panels -= 1;
        } else if (panel.status_name !== 'available' && updatedPanel.status_name === 'available') {
            building.total_available_panels += 1;
            field.available_panels += 1;
        }

        field.panels[field.panels.indexOf(panel)] = updatedPanel;
    },
    [UPDATE_ALL_PANEL_PRICES] (state, data) {
        const building = this.getters.get_building(data.building.id);
        const fieldIndex = building.fields.findIndex(one => one.id === data.id);

        building.fields[fieldIndex] = data;
    },
    [DELETE_PANEL] (state, deletedPanel) {
        const building = state.buildings.find(one => one.id === deletedPanel.building_id);
        const field = building.fields.find(one => one.id === deletedPanel.field_id);
        const panel = field.panels.find(one => one.id === deletedPanel.id);

        field.panels.splice(field.panels.indexOf(panel), 1);
        field.panels.count -= 1;
        field.number_of_panels -= 1;
        building.total_panels -= 1;

        if (deletedPanel.status_name === 'available') {
            building.total_available_panels -= 1;
            field.available_panels -= 1;
        }
    },
    [RESET_STATE] () {
        this.replaceState(initialState);
    },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js